
/*
 * ACTIONS
 */

export const OPEN_SNACKBAR = 'Snackbar/OPEN_SNACKBAR';
export const CLOSE_SNACKBAR = 'Snackbar/CLOSE_SNACKBAR';
export const CLOSE_SNACKBAR_PAGE_CHANGE = 'Snackbar/CLOSE_SNACKBAR_PAGE_CHANGE';
